<template>
  <div class="cart__overlay" :style="`height: ${overlayHeight}px`"></div>
  <div
    class="cart__wrapper"
    ref="cartWrapper"
    :class="{
      'cart__wrapper-menu-closed': !menuStore.isOpen,
      'cart__wrapper-menu-opened': menuStore.isOpen,
    }"
  >
    <div class="cart">
      <div class="cart__amount">
        <div class="cart__logo">
          <svg
            width="24"
            height="19"
            viewBox="0 0 24 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.99941 19C4.71608 19 4.45775 18.9127 4.22441 18.738C3.99108 18.5627 3.83275 18.3333 3.74941 18.05L0.949413 7.95C0.86608 7.71667 0.903413 7.5 1.06141 7.3C1.22008 7.1 1.43275 7 1.69941 7H6.74941L11.1494 0.45C11.2327 0.316667 11.3494 0.208333 11.4994 0.125C11.6494 0.0416667 11.8077 0 11.9744 0C12.1411 0 12.2994 0.0416667 12.4494 0.125C12.5994 0.208333 12.7161 0.316667 12.7994 0.45L17.1994 7H22.2994C22.5661 7 22.7787 7.1 22.9374 7.3C23.0954 7.5 23.1327 7.71667 23.0494 7.95L20.2494 18.05C20.1661 18.3333 20.0077 18.5627 19.7744 18.738C19.5411 18.9127 19.2827 19 18.9994 19H4.99941ZM5.49941 17H18.4994L20.6994 9H3.29941L5.49941 17ZM11.9994 15C12.5494 15 13.0204 14.8043 13.4124 14.413C13.8037 14.021 13.9994 13.55 13.9994 13C13.9994 12.45 13.8037 11.979 13.4124 11.587C13.0204 11.1957 12.5494 11 11.9994 11C11.4494 11 10.9787 11.1957 10.5874 11.587C10.1954 11.979 9.99941 12.45 9.99941 13C9.99941 13.55 10.1954 14.021 10.5874 14.413C10.9787 14.8043 11.4494 15 11.9994 15ZM9.17441 7H14.7994L11.9744 2.8L9.17441 7ZM5.49941 17H18.4994H5.49941Z"
              fill="#498388"
            />
          </svg>
        </div>

        <p>
          <!-- <span>{{ productCount }}</span> -->
          Dodaj nowe produkty do koszyka
        </p>
      </div>
      <button class="cart__button" @click="addProductsToCart">
        <svg
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.8277 8H8.65631V14H6.59916V8H0.427734V6H6.59916V0H8.65631V6H14.8277V8Z"
            fill="white"
          />
        </svg>

        Dodaj Produkty
      </button>
    </div>
  </div>
</template>

<script setup>
import { inject, ref, onMounted } from "vue";
import { useMenuStore } from "@/stores/menu.store";
import { useShoppingListStore } from "@/stores/shoppingList.store";

const props = defineProps({
  shoppingListId: {},
});

const menuStore = useMenuStore();
const store = useShoppingListStore();

const overlayHeight = ref(72);
const cartWrapper = ref();
onMounted(() => {
  overlayHeight.value = cartWrapper.value.clientHeight;
});

// const productCount = computed(() => {
//   const count = store.data.reduce((acc, val) => {
//     val.shoppingListRooms.forEach((room) => {
//       room.shoppingListRoomProducts.forEach((product) => {
//         acc += product.amount;
//       });
//     });
//     return acc;
//   }, 0);
//   return count;
// });
const emitter = inject("emitter");
async function addProductsToCart() {
  try {
    const data = await store.addToCart({
      shoppingListId: props.shoppingListId,
    });
    emitter.emit("updateShoppingCart", { data });
  } catch (error) {
    console.error(error);
  }
  // const products = [];
  // store.data.forEach((list) => {
  //   list.shoppingListRooms.forEach((room) => {
  //     room.shoppingListRoomProducts.forEach((product) => {
  //       products.push({ id: product.id, amount: product.amount });
  //     });
  //   });
  // });
}
</script>
<style lang="scss" scoped>
.cart {
  border-radius: 10px;
  background: #eef4f4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem;

  &__wrapper {
    z-index: 10;
    padding: 2rem 5rem;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    right: 0;

    &-menu-opened {
      width: calc(100% - 320px);
      @media screen and (max-width: 1199px) {
        width: calc(100% - 190px);
      }
    }
    &-menu-closed {
      width: calc(100% - 80px);
    }

    @media screen and (max-width: 767px) {
      width: calc(100%);
    }
  }

  &__overlay {
    width: 100%;
    height: 72px;
  }
  &__amount {
    display: flex;
    align-items: center;
    gap: 2rem;
  }
  &__logo {
    background-color: white;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
  }
  p {
    font-weight: 500;
    font-size: 2.25rem;
    color: #498388;
  }
  span {
    font-size: 1.75rem;
    margin-right: 0.5rem;
  }
  &__button {
    background: #498388;
    border-radius: 6px;
    border: none;
    transition: 350ms;
    cursor: pointer;
    padding: 1rem 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    font-weight: 500;
    font-size: 1.5rem;

    color: #ffffff;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
